import React from 'react';
import cx from 'classnames';

import classes from './Icons.module.scss';

const Icons = ({ className, component }) => {
  return (
    <span className={cx('anticon', classes.wrapper, className)}>
      {component}
    </span>
  );
};

export default Icons;
